(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fk-kit-contents"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-fkk-top]');
      if (!link) return;
      var form = document.querySelector('product-form, .product-form');
      if (!form) return;
      e.preventDefault();
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      form.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      var btn = form.querySelector('[type="submit"]');
      if (btn) setTimeout(function () { btn.focus({ preventScroll: true }); }, reduce ? 0 : 500);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fk-kit-launch-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function init(bar) {
      if (bar.dataset.fklInit) return;
      bar.dataset.fklInit = '1';
      var end = Date.parse(bar.dataset.end);
      var clock = bar.querySelector('[data-fkl-clock]');
      if (!clock || isNaN(end)) return;
      var timer;
      function tick() {
        var left = end - Date.now();
        if (left <= 0) {
          clearInterval(timer);
          var ended = bar.dataset.endedText;
          if (ended) {
            bar.querySelector('.fkl__inner').innerHTML = '<p class="fkl__offer">' + ended.replace(/</g, '&lt;') + '</p>';
          } else {
            bar.hidden = true;
          }
          return;
        }
        var s = Math.floor(left / 1000);
        var d = Math.floor(s / 86400);
        var h = Math.floor((s % 86400) / 3600);
        var m = Math.floor((s % 3600) / 60);
        var sec = s % 60;
        clock.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(sec) + 's';
      }
      tick();
      timer = setInterval(tick, 1000);
    }
    function run() { document.querySelectorAll('.fkl').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.sticky = this.header.querySelector('sticky-header');
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      document.addEventListener('DOMContentLoaded', this.convertToFixed);
      window.addEventListener('resize', this.convertToFixed, {passive: true});

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    convertToFixed = () => {
      this.header.style.setProperty('--sticky-header-height', `${this.sticky.offsetHeight}px`);
      this.sticky.style.position = 'fixed';
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollThreshold = 80;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > scrollThreshold) {
        this.shrink();
      } else {
        this.expand();
      }
    }

    shrink() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.header.classList.add('shopify-section-header-scrolled');
    }

    expand() {
      this.expanded = true;
      this.header.classList.remove('shopify-section-header-scrolled');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  const heroSlideshows = document.querySelectorAll('.hero-slideshow');
  heroSlideshows.forEach(section => {
    const buttons = [...section.querySelectorAll('[data-activate-slide]')];
    const slides  = [...section.querySelectorAll('[data-slide]')];
    let currentIndex = 0;

    let timeout = setTimeout(nextSlide, 4000);

    buttons.forEach(button => button.addEventListener('click', activateOnClick));

    function activateSlide(slideNum) {
      let slide = slides[currentIndex];
      let button = buttons[currentIndex];
      slide.removeAttribute('data-active');
      button.removeAttribute('data-current');

      currentIndex = slideNum % slides.length;

      slide = slides[currentIndex];
      button = buttons[currentIndex];
      slide.setAttribute('data-active', 'true');
      button.setAttribute('data-current', 'true');

      queueNextSlide();
    }

    function activateOnClick(e) {
      const slideNum = Number(e.currentTarget.getAttribute('data-activate-slide'));
      activateSlide(slideNum - 1);
    }

    function queueNextSlide() {
      clearTimeout(timeout);
      timeout = setTimeout(nextSlide, 4000);
    }

    function nextSlide() {
      activateSlide(currentIndex + 1);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nu-expandable-text"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
        const triggers = document.querySelectorAll('.nu-expandable-text__toggle');
        triggers.forEach(trigger => {
            trigger.addEventListener('click', () => {
                const isOpen = trigger.getAttribute('aria-expanded') === 'true';
                const parentSection = document.getElementById(trigger.getAttribute('aria-controls'));

                if (isOpen) {
                    parentSection.classList.remove('open');
                    trigger.setAttribute('aria-expanded', 'false');
                } else {
                    parentSection.classList.add('open');
                    trigger.setAttribute('aria-expanded', 'true');
                }
            })
        });
    })

  } catch(e) { console.error(e); }
})();
})();
